import {Directive, ElementRef, HostListener, Input, Output} from '@angular/core';

@Directive({
  selector: '[appFormattedNumber]'
})
export class FormattedNumberDirective {
}
